import React, { useEffect, useState } from 'react';

import { Button, Card, Text, TextInput, Tooltip } from '@mantine/core';
import { IconSearch, IconX } from '@tabler/icons-react';

import { useStyles } from '../styles';

interface IFlowTriggerSearchList {
  choicesList: string[];
  // Keyed by trigger. Only the triggers with help text have an entry.
  descriptions?: Record<string, string>;
  handleCardClick: (choice: string) => void;
}

const FlowTriggerSearchList = ({
  choicesList,
  descriptions,
  handleCardClick,
}: IFlowTriggerSearchList): JSX.Element => {
  const { classes } = useStyles();

  const [filteredList, setFilteredList] = useState<string[]>([]);
  const [search, setSearch] = useState('');

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const value = event.target?.value || '';
    setSearch(value);
  };

  const clearSearch = (): void => {
    setSearch('');
    setFilteredList(choicesList);
  };

  useEffect(() => {
    if (search) {
      const filtered = choicesList.filter(choice => choice.toLowerCase().includes(search.toLowerCase()));
      setFilteredList(filtered);
    } else {
      setFilteredList(choicesList);
    }
  }, [search, choicesList]);

  return (
    <>
      <TextInput
        placeholder='Search...'
        icon={<IconSearch size={18} />}
        value={search}
        onChange={handleSearchChange}
        rightSection={
          search ? (
            <Button onClick={clearSearch} variant='subtle' size='xs' style={{ marginRight: -8 }}>
              <IconX size={16} />
            </Button>
          ) : null
        }
        style={{ width: '80%', maxWidth: '400px', marginBottom: '20px' }}
      />
      {filteredList.map(choice => (
        <Tooltip
          key={choice}
          label={descriptions?.[choice]}
          disabled={!descriptions?.[choice]}
          multiline
          withArrow
          position='bottom'
          width={260}
        >
          <Card
            className={classes.clickableCard}
            shadow='sm'
            p='lg'
            radius='md'
            withBorder
            style={{ width: '90%', maxWidth: '300px', marginBottom: '10px' }}
            onClick={() => handleCardClick(choice)}
          >
            <Text>{choice}</Text>
          </Card>
        </Tooltip>
      ))}
    </>
  );
};

export default FlowTriggerSearchList;
